import { all, put, takeLatest } from 'redux-saga/effects';

import {
  ADD_ITEM,
  ADD_ITEM_FAILURE,
  ADD_ITEM_SUCCESS,
  DELETE_ITEM,
  DELETE_ITEM_FAILURE,
  DELETE_ITEM_SUCCESS,
  EDIT_ITEM,
  EDIT_ITEM_FAILURE,
  EDIT_ITEM_SUCCESS,
  GET_ITEMS_COUNTING_REPORT,
  GET_ITEMS_COUNTING_REPORT_FAILURE,
  GET_ITEMS_COUNTING_REPORT_SUCCESS,
  GET_ITEMS_LIST,
  GET_ITEMS_LIST_FAILURE,
  GET_ITEMS_LIST_SUCCESS,
  GET_ITEMS_TRANSACTIONS_LIST,
  GET_ITEMS_TRANSACTIONS_LIST_FAILURE,
  GET_ITEMS_TRANSACTIONS_LIST_SUCCESS,
  GET_ITEM_COUNTING_DASHBOARD_DATA,
  GET_ITEM_COUNTING_DASHBOARD_DATA_FAILURE,
  GET_ITEM_COUNTING_DASHBOARD_DATA_SUCCESS,
  GET_ITEM_TRANSACTIONS_DASHBOARD_DATA,
  GET_ITEM_TRANSACTIONS_DASHBOARD_DATA_FAILURE,
  GET_ITEM_TRANSACTIONS_DASHBOARD_DATA_SUCCESS,
  GET_TRANSFERRING_REQUESTS_LIST,
  GET_TRANSFERRING_REQUESTS_LIST_FAILURE,
  GET_TRANSFERRING_REQUESTS_LIST_SUCCESS,
} from '../../modules/constants';
import { defaultApi } from '../../utils/axiosApi';

function* handleGetItemsList({ payload }) {
  try {
    const queryParams = new URLSearchParams(payload).toString();
    const url = `/albait/items/?${queryParams}`;
    const response = yield defaultApi(url, 'GET', null);
    yield put({
      type: GET_ITEMS_LIST_SUCCESS,
      payload: response,
    });
  } catch (err) {
    yield put({
      type: GET_ITEMS_LIST_FAILURE,
      payload: err,
    });
  }
}

function* handleAddItem({ payload }) {
  try {
    const response = yield defaultApi('/albait/items/', 'POST', payload);
    yield put({ type: ADD_ITEM_SUCCESS, payload: response });
    yield put({ type: GET_ITEMS_LIST }); // Refresh the list after adding
  } catch (err) {
    yield put({ type: ADD_ITEM_FAILURE, payload: err });
  }
}

function* handleEditItem({ payload }) {
  try {
    const response = yield defaultApi(
      `/albait/items/${payload.id}/`,
      'PUT',
      payload,
    );
    yield put({ type: EDIT_ITEM_SUCCESS, payload: response });
    yield put({ type: GET_ITEMS_LIST }); // Refresh the list after editing
  } catch (err) {
    yield put({ type: EDIT_ITEM_FAILURE, payload: err });
  }
}

function* handleDeleteItem({ payload }) {
  try {
    yield defaultApi(`/albait/items/${payload.id}/`, 'DELETE');
    yield put({ type: DELETE_ITEM_SUCCESS, payload: payload.id });
    yield put({ type: GET_ITEMS_LIST }); // Refresh the list after deleting
  } catch (err) {
    yield put({ type: DELETE_ITEM_FAILURE, payload: err });
  }
}

function* handleGetItemCountingDashboardData({ payload }) {
  try {
    const queryParams = new URLSearchParams(payload).toString();
    const url = `/albait/dashboard/office-item-inventory-summary/?${queryParams}`;
    const response = yield defaultApi(url, 'GET', null);
    yield put({
      type: GET_ITEM_COUNTING_DASHBOARD_DATA_SUCCESS,
      payload: response,
    });
  } catch (err) {
    yield put({
      type: GET_ITEM_COUNTING_DASHBOARD_DATA_FAILURE,
      payload: err,
    });
  }
}

function* handleGetItemsCountingReport({ payload }) {
  try {
    const queryParams = new URLSearchParams(payload).toString();
    const url = `/albait/counting-sub-tasks/?${queryParams}`;
    const response = yield defaultApi(url, 'GET', null);
    yield put({ type: GET_ITEMS_COUNTING_REPORT_SUCCESS, payload: response });
  } catch (err) {
    yield put({ type: GET_ITEMS_COUNTING_REPORT_FAILURE, payload: err });
  }
}

function* handleGetTransferReport({ payload }) {
  try {
    const queryParams = new URLSearchParams(payload).toString();
    // const url = `/albait/counting-report/?${queryParams}`;
    // const response = yield defaultApi(url, 'GET', null);

    const response = {
      status: 200,
      data: [
        {
          item_name: 'Table',
          item_id: '1',
          allotted_quantity: 5000,
          received_quantity: 1000,
          decreased_quantity: 500,
          current_quantity: 500,
          remaining: -4500,
          remaining_with_sign: '-4500',
        },
        {
          item_name: 'Chair',
          item_id: '2',
          allotted_quantity: 3000,
          received_quantity: 1000,
          decreased_quantity: 700,
          current_quantity: 300,
          remaining: -2700,
          remaining_with_sign: '-2700',
        },
        {
          item_name: 'Desk',
          item_id: '3',
          allotted_quantity: 4000,
          received_quantity: 1500,
          decreased_quantity: 900,
          current_quantity: 600,
          remaining: -3400,
          remaining_with_sign: '-3400',
        },
        {
          item_name: 'Sofa',
          item_id: '4',
          allotted_quantity: 2000,
          received_quantity: 1200,
          decreased_quantity: 600,
          current_quantity: 600,
          remaining: -1400,
          remaining_with_sign: '-1400',
        },
        {
          item_name: 'Cupboard',
          item_id: '5',
          allotted_quantity: 4500,
          received_quantity: 1800,
          decreased_quantity: 750,
          current_quantity: 1050,
          remaining: -3450,
          remaining_with_sign: '-3450',
        },
        {
          item_name: 'Shelf',
          item_id: '6',
          allotted_quantity: 3500,
          received_quantity: 900,
          decreased_quantity: 500,
          current_quantity: 400,
          remaining: -3100,
          remaining_with_sign: '-3100',
        },
        {
          item_name: 'Bed',
          item_id: '7',
          allotted_quantity: 4400,
          received_quantity: 2500,
          decreased_quantity: 1200,
          current_quantity: 1300,
          remaining: -4700,
          remaining_with_sign: '-4700',
        },
        {
          item_name: 'Cabinet',
          item_id: '8',
          allotted_quantity: 2500,
          received_quantity: 900,
          decreased_quantity: 400,
          current_quantity: 500,
          remaining: -2000,
          remaining_with_sign: '-2000',
        },
        {
          item_name: 'Bench',
          item_id: '9',
          allotted_quantity: 3200,
          received_quantity: 1100,
          decreased_quantity: 550,
          current_quantity: 550,
          remaining: -2650,
          remaining_with_sign: '-2650',
        },
        {
          item_name: 'Dresser',
          item_id: '10',
          allotted_quantity: 2800,
          received_quantity: 900,
          decreased_quantity: 650,
          current_quantity: 250,
          remaining: -2550,
          remaining_with_sign: '-2550',
        },
        {
          item_name: 'Table',
          item_id: '1',
          allotted_quantity: 5000,
          received_quantity: 1000,
          decreased_quantity: 500,
          current_quantity: 500,
          remaining: -4500,
          remaining_with_sign: '-4500',
        },
        {
          item_name: 'Chair',
          item_id: '2',
          allotted_quantity: 3000,
          received_quantity: 1000,
          decreased_quantity: 700,
          current_quantity: 300,
          remaining: -2700,
          remaining_with_sign: '-2700',
        },
        {
          item_name: 'Desk',
          item_id: '3',
          allotted_quantity: 4000,
          received_quantity: 1500,
          decreased_quantity: 900,
          current_quantity: 600,
          remaining: -3400,
          remaining_with_sign: '-3400',
        },
        {
          item_name: 'Sofa',
          item_id: '4',
          allotted_quantity: 2000,
          received_quantity: 1200,
          decreased_quantity: 600,
          current_quantity: 600,
          remaining: -1400,
          remaining_with_sign: '-1400',
        },
        {
          item_name: 'Cupboard',
          item_id: '5',
          allotted_quantity: 4500,
          received_quantity: 1800,
          decreased_quantity: 750,
          current_quantity: 1050,
          remaining: -3450,
          remaining_with_sign: '-3450',
        },
        {
          item_name: 'Shelf',
          item_id: '6',
          allotted_quantity: 3500,
          received_quantity: 900,
          decreased_quantity: 500,
          current_quantity: 400,
          remaining: -3100,
          remaining_with_sign: '-3100',
        },
        {
          item_name: 'Bed',
          item_id: '7',
          allotted_quantity: 4100,
          received_quantity: 2500,
          decreased_quantity: 1200,
          current_quantity: 1300,
          remaining: -4700,
          remaining_with_sign: '-4700',
        },
        {
          item_name: 'Cabinet',
          item_id: '8',
          allotted_quantity: 2500,
          received_quantity: 900,
          decreased_quantity: 400,
          current_quantity: 500,
          remaining: -2000,
          remaining_with_sign: '-2000',
        },
        {
          item_name: 'Bench',
          item_id: '9',
          allotted_quantity: 3200,
          received_quantity: 1100,
          decreased_quantity: 550,
          current_quantity: 550,
          remaining: -2650,
          remaining_with_sign: '-2650',
        },
        {
          item_name: 'Dresser',
          item_id: '10',
          allotted_quantity: 2800,
          received_quantity: 900,
          decreased_quantity: 650,
          current_quantity: 250,
          remaining: -2550,
          remaining_with_sign: '-2550',
        },
      ],
    };
    yield put({
      type: GET_TRANSFERRING_REQUESTS_LIST_SUCCESS,
      payload: response,
    });
  } catch (err) {
    yield put({
      type: GET_TRANSFERRING_REQUESTS_LIST_FAILURE,
      payload: err,
    });
  }
}

function* handleGetItemsTransactionsList({ payload }) {
  try {
    const queryParams = new URLSearchParams(payload).toString();
    const url = `/albait/transaction-sub-tasks/${
      queryParams ? '?' + queryParams : ''
    }`;
    const response = yield defaultApi(url, 'GET', null);
    yield put({
      type: GET_ITEMS_TRANSACTIONS_LIST_SUCCESS,
      payload: response,
    });
  } catch (err) {
    yield put({
      type: GET_ITEMS_TRANSACTIONS_LIST_FAILURE,
      payload: err,
    });
  }
}
function* handleGetItemTransactionDashboardData({ payload }) {
  try {
    const queryParams = new URLSearchParams(payload).toString();
    const url = `/albait/dashboard/inventory-summary/?${queryParams}`;
    const response = yield defaultApi(url, 'GET', null);
    yield put({
      type: GET_ITEM_TRANSACTIONS_DASHBOARD_DATA_SUCCESS,
      payload: response,
    });
  } catch (err) {
    yield put({
      type: GET_ITEM_TRANSACTIONS_DASHBOARD_DATA_FAILURE,
      payload: err,
    });
  }
}
export default function* root() {
  yield all([
    takeLatest(GET_ITEMS_LIST, handleGetItemsList),
    takeLatest(ADD_ITEM, handleAddItem),
    takeLatest(EDIT_ITEM, handleEditItem),
    takeLatest(DELETE_ITEM, handleDeleteItem),
    takeLatest(
      GET_ITEM_COUNTING_DASHBOARD_DATA,
      handleGetItemCountingDashboardData,
    ),
    takeLatest(GET_ITEMS_COUNTING_REPORT, handleGetItemsCountingReport),
    takeLatest(GET_TRANSFERRING_REQUESTS_LIST, handleGetTransferReport),
    takeLatest(GET_ITEMS_TRANSACTIONS_LIST, handleGetItemsTransactionsList),
    takeLatest(
      GET_ITEM_TRANSACTIONS_DASHBOARD_DATA,
      handleGetItemTransactionDashboardData,
    ),
  ]);
}
const res = {
  status: 200,
  data: [
    {
      id: '1',
      task_code: 'TK-0456',
      public_zone_name: 'Zone A',
      office: 'New York HQ',
      assignees: {
        id: '060a9922-fded-41b8-9830-2f619371f6cf',
        name: 'عبدالله بن محمد نور احمد  قاري',
        avatar: 'https://randomuser.me/api/portraits/men/45.jpg',
      },
      created_at: '2025-04-05T10:15:00Z',
      item_name: 'Fire Extinguisher',
      current_quantity: '5',
      quantity: '4',
      employee_note: 'One was damaged',
      evidences: [
        {
          image:
            'https://app-albait-evidence-bucket.s3.amazonaws.com/media/image-evidence/8483291c-7234-42a1-a9db-eeecceaf4cd7/2024-06-12/6179DCE6-3A9C-4569-A512-B_Osl5x04.jpg',
          audio: null,
        },
      ],
    },
    {
      id: '2',
      task_code: 'TK-0823',
      public_zone_name: 'Zone B',
      office: 'Los Angeles Office',
      assignees: {
        id: '42eddcd2-2bff-4764-8a8b-cb3c39801992',
        name: 'عمار سامي مصطفى باخدلق',
        avatar: 'https://randomuser.me/api/portraits/men/24.jpg',
      },
      created_at: '2025-04-03T09:00:00Z',
      item_name: 'Safety Helmet',
      current_quantity: '12',
      quantity: '12',
      employee_note: 'All accounted for',
      evidences: [
        {
          image:
            'https://app-albait-evidence-bucket.s3.amazonaws.com/media/image-evidence/8483291c-7234-42a1-a9db-eeecceaf4cd7/2024-06-12/6179DCE6-3A9C-4569-A512-B_Osl5x04.jpg',
          audio: null,
        },
      ],
    },
    {
      id: '3',
      task_code: 'TK-0912',
      public_zone_name: 'Zone C',
      office: 'Chicago Hub',
      assignees: {
        id: '27b5a32f-4705-4278-9ebb-be37b5e08731',
        name: 'محمد بن زهير محمد الحازمي',
        avatar: 'https://randomuser.me/api/portraits/men/77.jpg',
      },
      created_at: '2025-04-01T14:20:00Z',
      item_name: 'Toolbox',
      current_quantity: '3',
      quantity: '2',
      employee_note: 'Missing wrench set',
      evidences: [
        {
          image:
            'https://app-albait-evidence-bucket.s3.amazonaws.com/media/image-evidence/8483291c-7234-42a1-a9db-eeecceaf4cd7/2024-06-12/6179DCE6-3A9C-4569-A512-B_Osl5x04.jpg',
          audio: null,
        },
      ],
    },
    {
      id: '4',
      task_code: 'TK-0765',
      public_zone_name: 'Warehouse 1',
      office: 'Houston Station',
      assignees: {
        id: '10f72634-ab20-40c4-92bd-75a7d053d0b1',
        name: 'حاتم بن احمد احمد الحرازي',
        avatar: 'https://randomuser.me/api/portraits/men/61.jpg',
      },
      created_at: '2025-04-02T11:00:00Z',
      item_name: 'Ladder',
      current_quantity: '6',
      quantity: '6',
      employee_note: 'All checked',
      evidences: [
        {
          image:
            'https://app-albait-evidence-bucket.s3.amazonaws.com/media/image-evidence/8483291c-7234-42a1-a9db-eeecceaf4cd7/2024-06-12/6179DCE6-3A9C-4569-A512-B_Osl5x04.jpg',
          audio: null,
        },
      ],
    },
    {
      id: '5',
      task_code: 'TK-0389',
      public_zone_name: 'Zone D',
      office: 'San Francisco',
      assignees: {
        id: '8e034cf0-f4c0-434e-8076-57c56fac99c0',
        name: 'سالم بن عبدالله سالم بابكور',
        avatar: 'https://randomuser.me/api/portraits/men/53.jpg',
      },
      created_at: '2025-03-29T16:45:00Z',
      item_name: 'Battery Pack',
      current_quantity: '8',
      quantity: '6',
      employee_note: '2 batteries drained',
      evidences: [
        {
          image:
            'https://app-albait-evidence-bucket.s3.amazonaws.com/media/image-evidence/8483291c-7234-42a1-a9db-eeecceaf4cd7/2024-06-12/6179DCE6-3A9C-4569-A512-B_Osl5x04.jpg',
          audio: null,
        },
      ],
    },
    {
      id: '6',
      task_code: 'TK-0999',
      public_zone_name: 'Roof Access',
      office: 'Miami HQ',
      assignees: {
        id: 'b4a4f07b-bf37-4e64-80dc-ffea16829704',
        name: 'حسام بن طلال بن احمد تازي',
        avatar: 'https://randomuser.me/api/portraits/men/88.jpg',
      },
      created_at: '2025-04-04T13:15:00Z',
      item_name: 'Harness',
      current_quantity: '10',
      quantity: '11',
      employee_note: 'Strap missing on one',
      evidences: [
        {
          image:
            'https://app-albait-evidence-bucket.s3.amazonaws.com/media/image-evidence/8483291c-7234-42a1-a9db-eeecceaf4cd7/2024-06-12/6179DCE6-3A9C-4569-A512-B_Osl5x04.jpg',
          audio: null,
        },
      ],
    },
    {
      id: '7',
      task_code: 'TK-0561',
      public_zone_name: 'Main Entry',
      office: 'Seattle Branch',
      assignees: {
        id: 'fe689690-6a10-4694-91d3-038a2a078a2b',
        name: 'ياسر بن عمر عبدالله باهيثم',
        avatar: 'https://randomuser.me/api/portraits/men/29.jpg',
      },
      created_at: '2025-04-06T08:40:00Z',
      item_name: 'Visitor Badges',
      current_quantity: '50',
      quantity: '45',
      employee_note: '5 lost or unreturned',
      evidences: [
        {
          image:
            'https://app-albait-evidence-bucket.s3.amazonaws.com/media/image-evidence/8483291c-7234-42a1-a9db-eeecceaf4cd7/2024-06-12/6179DCE6-3A9C-4569-A512-B_Osl5x04.jpg',
          audio: null,
        },
      ],
    },
  ],
};
